import module from '72cms-ui/store/modules/base';
import helpers from '../helpers';

export default {
    modules: {
        splitter: splitter(),
        history: history(),
        notification: notification(),

        // CMS module
        login: module(helpers),
        customer: module(helpers),
        device: module(helpers),
        notifications: module(helpers),
        trips: module(helpers),
        trip: module(helpers),
        pages: module(helpers),
        page: module(helpers),
    },
}

function splitter() {
    return {
        namespaced: true,
        state: {
            open: false
        },
        mutations: {
            toggle (state, shouldOpen) {
                if (typeof shouldOpen === 'boolean') {
                    state.open = shouldOpen
                } else {
                    state.open = !state.open
                }
            }
        }
    }
}

function history() {
    return {
        namespaced: true,
        state: {
            pageStack: []
        },
        getters: {
            previous(state) {
                return _.chain(state).get('pageStack').last()
            },
            pageStack(state) {
                return state.pageStack
            },
        },
        mutations: {
            push(state, pageData) {
                state.pageStack.push(pageData)
            },
            pop(state) {
                state.pageStack.pop()
            },
        }
    }
}

function notification() {
    return {
        namespaced: true,
        state: {
            message: '',
            type: '',
            timestamp: Date.now(),
        },
        getters: {
            type: (state) => state.type,
            message: (state) => state.message,
            timestamp: (state) => state.timestamp,
        },
        actions: {
            push({ commit }, payload) {
                return commit('push', payload);
            },
        },
        mutations: {
            push(state, payload) {
                state.message = payload.message
                state.type = payload.type
                state.timestamp = Date.now()
            },
        }
    }
}




// WEBPACK FOOTER //
// ./src/store/index.js